import { FC, useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import QAResponseQuestionEntity from "../../../../../../../domain/entities/qa_response_question.entity";
import LocalizationContextType from "../../../../../../../domain/providers/localization/LocalizationContextType";
import ModalsContextType from "../../../../../../../domain/providers/modal/ModalsContextType";
import ButtonComponent from "../../../../../../components/button/button.component";
import LocalizationContext from "../../../../../../providers/localization/LocalizationContext";
import ModalsContext from "../../../../../../providers/modal/ModalsContext";
import KeyWordLocalization from "../../../../../../utils/KeyWordLocalization";
import Validators from "../../../../../../utils/Validators";
import EditResponseQuestionComponentProps from "./edit_qa_response_question_modal.component.props";

const EditResponseQuestionComponent: FC<EditResponseQuestionComponentProps> = ({ response, onSave, maxPoints }) => {
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
    const { i18n } = useContext(LocalizationContext) as LocalizationContextType;
    const [loading, setLoading] = useState(false);
    const { popModalCustom } = useContext(ModalsContext) as ModalsContextType;
    const selectedShort = watch(KeyWordLocalization.QAResponseQuestionEntityShort);

    const _handleSave = async (data: any) => {
        const updatedResponse: QAResponseQuestionEntity = {
            id: response.id,
            justification: data[KeyWordLocalization.QAResponseQuestionEntityJustification],
            points: parseInt(data[KeyWordLocalization.QAResponseQuestionEntityPoints]),
            short: data[KeyWordLocalization.QAResponseQuestionEntityShort],
            questionId: response.questionId,
            manualQuestion: data["manual_question"] || null,
        };

        setLoading(true);
        await onSave(updatedResponse);
        setLoading(false);
        popModalCustom();
    };

    const _handleLoad = () => {
        if (response) {
            const shortNormalized = response.short?.toLowerCase();
            if (shortNormalized === "yes") {
                setValue(KeyWordLocalization.QAResponseQuestionEntityShort, "YES");
            } else if (shortNormalized === "no") {
                setValue(KeyWordLocalization.QAResponseQuestionEntityShort, "NO");
            } else if (shortNormalized === "not applicable") {
                setValue(KeyWordLocalization.QAResponseQuestionEntityShort, "Not Applicable");
            } else {
                console.warn("short desconocido:", response.short);
            }
            setValue(KeyWordLocalization.QAResponseQuestionEntityPoints, response.points);
            setValue(KeyWordLocalization.QAResponseQuestionEntityJustification, response.justification);
        }
        console.log("Valor de response.short:", response.short);

    };
    

    const _handleCancel = () => popModalCustom();

    useEffect(() => {
        _handleLoad();
    }, [response]);

    return (
        <div className="edit_response_question_component">
            <div className="container">
                <form onSubmit={handleSubmit(_handleSave)} className="row">
                    {/* Campo Short */}
                    <div className={`form-group col-md-6 my-2 ${errors[KeyWordLocalization.QAResponseQuestionEntityShort] && 'error error_group'}`}>
                        <label className='form-label'>{i18n(KeyWordLocalization.QAResponseQuestionEntityShort)}</label>
                        <select
                            className="form-control"
                            disabled={loading}
                            {...register(KeyWordLocalization.QAResponseQuestionEntityShort, Validators({
                                required: true,
                            }))}
                        >
                            <option value="">{i18n(KeyWordLocalization.QAResponseQuestionEntitySelect)}</option>
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                            <option value="Not Applicable"> Not Applicable</option>
                        </select>
                        <ErrorMessage as={"aside"} errors={errors} name={KeyWordLocalization.QAResponseQuestionEntityShort} />
                    </div>

                    {/* Campo Points */}
                    <div className={`form-group col-md-6 my-2 ${errors[KeyWordLocalization.QAResponseQuestionEntityPoints] && 'error error_group'}`}>
                        <label className='form-label'>{i18n(KeyWordLocalization.QAResponseQuestionEntityPoints)}</label>
                        <input
                            type="number"
                            step={1}
                            className="form-control"
                            disabled={loading}
                            placeholder={i18n(KeyWordLocalization.QAResponseQuestionEntityPoints)}
                            {...register(KeyWordLocalization.QAResponseQuestionEntityPoints, Validators({
                                required: true,
                                minValue: 0,
                                maxValue: maxPoints,
                            }))}
                        />
                        <ErrorMessage as={"aside"} errors={errors} name={KeyWordLocalization.QAResponseQuestionEntityPoints} />
                    </div>
                    {/* Campo para nueva pregunta manual */}
                    <div className={`form-group col-md-12 my-2 ${errors['manual_question'] && 'error error_group'}`}>
                        <label className='form-label'>Pregunta manual (opcional)</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled={loading}
                            placeholder="Escribe aquí la nueva pregunta manual"
                            {...register("manual_question", Validators({
                                maxLength: 500,
                            }))}
                        />
                        <ErrorMessage as={"aside"} errors={errors} name="manual_question" />
                    </div>

                    {/* Campo Justification */}
                    <div className={`form-group col-md-12 my-2 ${errors[KeyWordLocalization.QAResponseQuestionEntityJustification] && 'error error_group'}`}>
                        <label className='form-label'>{i18n(KeyWordLocalization.QAResponseQuestionEntityJustification)}</label>
                        <textarea
                            className="form-control"
                            rows={5}
                            disabled={loading}
                            placeholder={i18n(KeyWordLocalization.QAResponseQuestionEntityJustification)}
                            {...register(KeyWordLocalization.QAResponseQuestionEntityJustification, Validators({
                                required: true,
                                minLength: 5,
                                maxLength: 500,
                            }))}
                        />
                        <ErrorMessage as={"aside"} errors={errors} name={KeyWordLocalization.QAResponseQuestionEntityJustification} />
                    </div>

                    {/* Botones */}
                    <div className="px-2 mt-2 container_buttons">
                        <ButtonComponent type="button" onClick={_handleCancel} design="primaryOutline" text={i18n(KeyWordLocalization.EditQaResponseQuestionModalCancel)} />
                        <ButtonComponent type="submit" isLoading={loading} text={i18n(KeyWordLocalization.EditQaResponseQuestionModalSave)} />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditResponseQuestionComponent;